import React from "react"
import intl from "react-intl-universal"
import { Text, View } from "@react-pdf/renderer"
import { styles } from "./styles"
import { fnFormatDate } from "../../../../../../../utils/date"

export const Footer = ({ user }) => {
  return (
    <View style={styles.footer} fixed>
      <View style={styles.footerInfo}>
        <View style={styles.row}>
          <Text style={styles.footerText}>Gerado em: </Text>
          <Text style={styles.footerTextBold}>
            {fnFormatDate(new Date(), `DD/MM/YYYY`)} {intl.get("ciqReport.pdf.footer.at")}{" "}
            {fnFormatDate(new Date(), `HH:mm`)}
          </Text>
        </View>
        <Text style={styles.footerText}>•</Text>
        <View style={styles.row}>
          <Text style={styles.footerText}>{intl.get("ciqReport.pdf.footer.by")} </Text>
          <Text style={styles.footerTextBold}>{user?.cname}</Text>
        </View>
      </View>
      <Text
        style={styles.footerPagination}
        render={({ pageNumber, totalPages }) => `${pageNumber}/${totalPages}`}
      />
    </View>
  )
}
